import axiosInstance from "./axiosInstance";

export const uploadFileGivePath =  async (file) => {
    try {
        const formdata = new FormData();
        formdata.append("file", file);
        const response = await axiosInstance.post('/uploadFileGivePath',formdata, {
            headers: {
                "Content-Type":"multipart/form-data"
            }
        })
        return response?.data;
    }   catch (e) {
        console.log(e.toString());
    } 
}


